export { default as ArrowRed } from './arrow-red.svg?react';
export { default as arrowRightIcon } from './arrow-right.svg?react';
export { default as ArrowWhite } from './arrow-white.svg?react';
export { default as chevronDownSmallIcon } from './chevron-down-icon-small.svg?react';
export { default as ChevronDown } from './chevron-down.svg?react';
export { default as ChevronLeft } from './chevron-left.svg?react';
export { default as ChevronRight } from './chevron-right.svg?react';
export { default as CircleQuestionMark } from './circle-question-mark.svg?react';
export { default as CloseBtn } from './close.svg?react';
export { default as discordIcon } from './discord.svg?react';
export { default as EmailRed } from './email-red.svg?react';
export { default as Email } from './email.svg?react';
export { default as Eye } from './eye.svg?react';
export { default as Facebook } from './facebook.svg?react';
export { default as Filter } from './filter.svg?react';
export { default as HamburgerIcon } from './hamburger-icon.svg?react';
export { default as Heart } from './heart.svg?react';
export { default as Hint } from './hint.svg?react';
export { default as IconImage } from './image.svg?react';
export { default as IconHome } from './home-icon.svg?react';
export { default as Info } from './info.svg?react';
export { default as IconFeatureDefault } from './icon-feature-default.svg?react';
export { default as IconDotBlack } from './iconDotBlack.svg?react';
export { default as IconNextRed } from './iconNextRed.svg?react';
export { default as Indeterminate } from './indeterminate.svg?react';
export { default as Instagram } from './instagram.svg?react';
export { default as LinkedIn } from './linkedin.svg?react';
export { default as lockIcon } from './lock-icon.svg?react';
export { default as MapPin } from './map-pin.svg?react';
export { default as OnAction } from './on-action.svg?react';
export { default as OpenLink } from './open-link.svg?react';
export { default as PaperPlane } from './paper-plane.svg?react';
export { default as PersonDefault } from './person-default.svg?react';
export { default as Phone } from './phone.svg?react';
export { default as PortalLogo } from './portal-logo.svg?react';
export { default as Robot } from './robot.svg?react';
export { default as Search } from './search-icon.svg?react';
export { default as Tick } from './tick.svg?react';
export { default as TikTok } from './tiktok.svg?react';
export { default as cancelIcon } from './xIcon.svg?react';
export { default as Youtube } from './youtube.svg?react';
export { default as XSocial } from './x-social.svg?react';
export { default as Threads } from './threads.svg?react';

export { default as FileBend } from './file-bend.svg?react';
export { default as MilestoneArrowDown } from './milestone-arrow-down.svg?react';
export { default as MilestoneArrowRight } from './milestone-arrow-right.svg?react';
export { default as PlayCircle } from './play-circle.svg?react';
export { default as PlayCircleWhite } from './play-circle-white.svg?react';
export { default as SearchFilter } from './search-filter.svg?react';
export { default as EditList } from './edit-list.svg?react';
export { default as LayoutThird } from './layout-third.svg?react';
export { default as BrowserIcon } from './browser.svg?react';
export { default as ThreeDotHorizontal } from './three-dot-horizontal.svg?react';
export { default as Pinterest } from './pinterest.svg?react';
export { default as Linked } from './chain-link.svg?react';
export { default as SpinnerIcon } from './spinner.icon.svg?react';
export { default as share } from './share-icon.svg?react';
export { default as ThumbsUp } from './thumbs-up.svg?react';
export { default as ThumbsDown } from './thumbs-down.svg?react';
export { default as Warning } from './warning.svg?react';
export { default as CircleCheck } from './check-circle.svg?react';
export { default as checkCircle } from './check-circle.svg?react';
